// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []

import store from '@/store/index.js'
import axios from 'axios';
import qs from 'qs';
import {
	Message
} from 'element-ui'
import {
	Toast
} from 'vant';
import router from '@/router'

// 弹窗
function toast(message) {
	console.log('弹窗')
	if (store.getters.isPc) {
		Message({
			message,
			type: 'error',
			duration: 3 * 1000
		})
	} else {
		Toast(message);
	}
}
// 刷新token
function refreshToken() {
	// service是当前request.js中已创建的axios实例
	return service.post('client/stu/refreshLogin', {
		refresh_token: store.getters.getRefreshToken || ''
	}).then(res => {
		store.dispatch('setToken', res.data.token);
		store.dispatch('setRefreshToken', res.data.refresh_token);
		return res.data
	})
}
// 刷新token
function refreshToken2() {
	// service是当前request.js中已创建的axios实例
	return service2.post('client/stu/refreshLogin', {
		refresh_token: store.getters.getRefreshToken || ''
	}).then(res => {
		store.dispatch('setToken', res.data.token);
		store.dispatch('setRefreshToken', res.data.refresh_token);
		return res.data
	})
}

axios.defaults.timeout = 5000
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'production') {
	var service1 = axios.create({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		baseURL: '/index.php/api/'
		// baseURL: 'http://www.pumcp.org.cn/index.php/api/'
	})
} else {
	var service1 = axios.create({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		baseURL: 'http://kepu.pumcp.com/index.php/api/',
	})
}



service1.interceptors.request.use(
	config => {
		config.data = config.data || {}
		config.data = qs.stringify(config.data)
		return config
	},
	error => {
		// do something with request error
		return Promise.reject(error)
	}
)
service1.interceptors.response.use(
	response => {
		return response.data
	},
	error => {
		// toast(error.message)
		toast('网络异常')
		return Promise.reject(error)
	}
)
if (process.env.NODE_ENV === 'production') {
	var service2 = axios.create({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		baseURL: 'https://hp.smedu.cn/api/'
	})
} else {
	var service2 = axios.create({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		baseURL: 'http://192.168.14.4:9517/api/',
		// baseURL: 'http://www.huapei.com/api/'
	})
}

// request interceptor
service2.interceptors.request.use(
	config => {
		let token = store.getters.getToken || ''
		config.data = config.data || {}
		config.data.token = token
		config.data = qs.stringify(config.data)
		return config
	},
	error => {
		// do something with request error
		return Promise.reject(error)
	}
)

// response interceptor
service2.interceptors.response.use(
	response => {
		const res = response.data
		res.code = Number(res.code)
		if (res.code === 11) {
			// code=11时候，提示重新登录
			toast('登录超时，请重新登录~');
			store.dispatch('logout').then(res => {
				setTimeout(() => {
					router.replace({
						path: '/'
					})
				}, 1000)
			})
			return Promise.reject('登录超时，请重新登录~')
		} else if (res.code === 10) {
			const config = response.config
			if (!isRefreshing) {
				isRefreshing = true
				return refreshToken2().then(res => {
					const {
						token
					} = res
					let data = config.data ? JSON.parse(config.data) : {}
					data.token = token
					config.data = data
					// 已经刷新了token，将所有队列中的请求进行重试
					requests.forEach(cb => cb(token))
					// 清空所有队列
					requests = []
					// 第一次检测出token失效的请求，重新发起请求
					return service(config)
				}).finally(() => {
					isRefreshing = false
				})
			} else {
				// 正在刷新token，将返回一个未执行resolve的promise
				return new Promise((resolve) => {
					// 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
					requests.push((token) => {
						let data = config.data ? JSON.parse(config.data) : {}
						data.token = token
						config.data = data
						resolve(service(config))
					})
				})
			}
		} else if (res.code !== 0) {
			toast(res.msg || 'Error')
			return Promise.reject(res.msg)
		} else {
			return res
		}
	},
	error => {
		// toast(error.message)
		toast('网络异常')
		return Promise.reject(error)
	}
)


export function post1(url, param = {}) {
	return service1.post(url, param);
}
export function post2(url, param = {}) {
	return service2.post(url, param);
}
